/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { BatchTestStore } from 'src/luis/types/stores/testPane/BatchTestStore';
import { BatchTestStoreHouse } from 'src/luis/types/stores/testPane/BatchTestStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an batch test store house,
 * which houses an array of batch test stores.
 */
export const createBatchTestStoreHouse = (): BatchTestStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<BatchTestStore>();

    const batchTestStoreHouse: SubtractStore<BatchTestStoreHouse, ResourceStoreHouse<BatchTestStore>> = {
        /**
         * Finds an batch test by the given name and returns undefined
         * if not found.
         *
         * @param name The name to search with.
         * @returns The batch test or undefined if not found.
         */
        findByName(name: string): BatchTestStore {
            return this.items.find(i => i.name === name);
        }
    };

    return extendObservable(resourcesStoreHouse, batchTestStoreHouse, { findByName: action }, { deep: false });
};
